import { render, staticRenderFns } from "./PersonalDetailsSection.vue?vue&type=template&id=a17c1b50&scoped=true&"
import script from "./PersonalDetailsSection.vue?vue&type=script&lang=js&"
export * from "./PersonalDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDetailsSection.vue?vue&type=style&index=0&id=a17c1b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17c1b50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCardText,VDatePicker,VExpandTransition,VMenu,VRadio,VRadioGroup,VTextField,VTextarea})
